import { Time } from 'common/utils';

import { intl } from 'i18n/Translations';

type GetRouteTime = (legs: google.maps.DirectionsLeg[]) => Time;

export const getGoogleRouteTime: GetRouteTime = (legs) => {
  const timestamp = legs.reduce((acc, { duration }) => (duration ? acc + duration.value : acc) , 0);
  const hours = Math.floor(timestamp / 60 / 60);
  const minutes = Math.floor(timestamp / 60) % 60;
  return `${hours} ${intl.formatMessage({ id: 'hours' })} ${minutes} ${intl.formatMessage({ id: 'min' })}`;
};
